import { useRoutes } from 'react-router-dom';
import { routes } from './routes';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import useWebSocketAlert from 'hooks/useWebSocketAlert';
import useYandexMetricaInit from 'hooks/useYandexMetricaInit';
import { useTabSync } from 'hooks/useTabSync';

declare global {
  interface Window {
    Pusher1: unknown;
    Echo1: unknown;
  }
}

window.Pusher1 = Pusher;

export const echo = new Echo({
  broadcaster: 'reverb',
  key: `${process.env.REACT_APP_REVERB_APP_KEY}`,
  wsHost: `${process.env.REACT_APP_REVERB_APP_HOST}`,
  wsPort: `${process.env.REACT_APP_REVERB_WS_PORT}`,
  wssPort: `${process.env.REACT_APP_REVERB_WSS_PORT}`,
  forceTLS: `${process.env.REACT_APP_REVERB_FORCE_TLS}` === 'true',
  wsPath: `${process.env.REACT_APP_REVERB_WS_PATH}`,
  enabledTransports: ['ws', 'wss'],

  authorizer: (channel: { name: string }, _options: unknown) => {
    return {
      authorize: (
        socketId: string,
        callback: (error: boolean, data?: unknown) => void,
      ) => {
        const authUrl = `${process.env.REACT_APP_API_URL}/broadcasting/auth`;
        fetch(authUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            ...(localStorage.getItem('token') && {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            }),
          },
          credentials: 'include',
          body: JSON.stringify({
            socket_id: socketId,
            channel_name: channel.name,
          }),
        })
          .then((response: Response) => {
            return response.json();
          })
          .then((data: unknown) => {
            callback(false, data);
          })
          .catch((error: unknown) => {
            console.error('Ошибка авторизации WS', error);
            callback(true, error);
          });
      },
    };
  },
});

window.Echo1 = echo;

function App() {
  useTabSync();
  useWebSocketAlert();
  useYandexMetricaInit();
  return useRoutes(routes);
}

export default App;
